import { Pagination } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface TFCPaginationProps {
  total: number;
  pageSize: number;
  pageSizeOptions?: string[];
  currentPage: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const TFCPagination: React.FC<TFCPaginationProps> = ({
  total = 0,
  pageSize = 15,
  currentPage,
  onPageChange,
  pageSizeOptions = ["15", "20", "30"],
}) => {

  console.log("TFCPagination", total, pageSize, currentPage);
  const handlePageChange = (page: number) => {
    onPageChange(page, pageSize);
  };

  return (
    <div className="paginationWrapper">
      <div className="pageSizeWrapper">
        <span>每页显示结果数</span>
        <div className="pageSizeOptions">
          {pageSizeOptions.map((size) => {
            return (
              <span
                key={size}
                className={
                  size === pageSize.toString() ? "option active" : "option"
                }
                onClick={() => {
                  if (size === pageSize.toString()) return;
                  onPageChange(1, parseInt(size));
                }}
              >
                {size}
              </span>
            );
          })}
        </div>
      </div>
      <div>
        <Pagination
          showSizeChanger={false}
          // hideOnSinglePage={true}
          defaultCurrent={1}
          total={total}
          pageSize={pageSize}
          onChange={handlePageChange}
          current={currentPage}
          itemRender={(_, type, originalElement) => {
            if (type === "prev") {
              return (
                <a>
                  <span
                    style={{
                      fontWeight: "bold",
                      padding: "0 4px",
                    }}
                  >
                    <LeftOutlined />
                  </span>
                  <span style={{ fontSize: "16px" }}>前页</span>
                </a>
              );
            }
            if (type === "next") {
              return (
                <a>
                  <span style={{ fontSize: "16px" }}>后页</span>
                  <span style={{ padding: "0 4px", fontWeight: "bold" }}>
                    <RightOutlined />
                  </span>
                </a>
              );
            }
            return originalElement;
          }}
        />
      </div>
    </div>
  );
};

export default TFCPagination;
